<template>
    <div class="container">
        <CommonBreadcrumb class="bread_block" /> 
        <BlogBanner />
        <BlogFilters :filters="filters" @toggleSort="toggleSort"/>
        
        <div v-if="error">
            <p>Error: {{ error?.message }}</p>
        </div>
        
        <div class="row" v-if="items.length">
            <BlogPreview v-for="item in items" :key="item.id" :item="item" />
        </div>

        <div class="loader min_height" v-if="status=='pending'">
            <img width="246" loading="lazy" height="246" alt="loader" src="~/assets/assets/loader.svg" />
        </div>

        <div class="show_more_block mt-4" v-if="nextPage">
            <div class="show_more_btn" @click="showMore()" >Show More</div>
        </div> 
    </div>
</template>

<script setup>
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
    import { encodeURL } from '~/helper';
    const route = useRoute();
    const nextPage = ref(false);
    const isSortToggle = ref(false)
    const router = useRouter();
    
    const items = ref([]);
    const error = ref(null);
    const filters = reactive({
        sort: 'newest',
        category: '',
        page: 1,
    });
    
    const setCategory = ()=>{
        if (route.params.type && route.params.sub_type) {
            filters.category = route.params.sub_type;        
        }  else {
            filters.category = '';
        }
    }   

    setCategory()

    function checkUrl(){
        if(route.query){
            if(route.query.sort && ['newest','popular', 'oldest'].includes(route.query.sort)){
                filters.page = 1
                filters.sort = route.query.sort;                
            }else {
                filters.sort = 'newest';
            }
        }
    }

    checkUrl()

    function updateUrl(){
        let urlPayload = {
            sort: filters.sort,
        }  
        // history.pushState({}, "", "?"+encodeURL(urlPayload));
        router.push( { query: urlPayload })
    }


    watch(() => route.query, () => {
        if(route.query){
            if(route.query.sort && ['newest','popular', 'oldest'].includes(route.query.sort)){
                filters.page = 1
                isSortToggle.value = true;
                filters.sort = route.query.sort;
                checkUrl()
            } else {
                isSortToggle.value = true;
                filters.sort = 'newest'; 
        }}
        }
    )

    const showMore = ()=>{
        filters.page++;
        refresh()
        updateUrl()

    }

    const toggleSort = (sortValue) => {
        filters.sort = sortValue;
        filters.page = 1;
        isSortToggle.value = true
        refresh();
        updateUrl();
    };

    const { data, error: Fetcherror, refresh, status }= await useFetch(useCountryPath(`/blog/${filters.category}/`), {
        query: filters,
        watch: [filters],
        transform: (res) => {
            if (res.data.data.length > 0) {
                
                // storing data 
                if(isSortToggle.value){
                    items.value = [...res.data.data]
                    isSortToggle.value = false
                }else{
                    items.value = [...items.value , ...res.data.data];
                }

                //is next data available 
                nextPage.value =  !!res.data.next_page_url;
                
            } else {
                nextPage.value= false
            }
        },
    });




</script>

<style scoped>
.show_more_block {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.show_more_btn {
    display: inline-block;
    font-size: 14px;
    padding: 12px 18px;
    color: #000;
    border: 1px solid #000;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
    min-width: 200px;
    border-radius: 4px;
}
.loader{
    display: flex;
    align-items: center;
    justify-content: center;
}

@media(max-width: 767px){
    .min_height{
        min-height: 150px;
    }
}
</style>